import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=19349409&scoped=true"
import script from "./Paper.vue?vue&type=script&lang=js"
export * from "./Paper.vue?vue&type=script&lang=js"
import style0 from "./Paper.vue?vue&type=style&index=0&id=19349409&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19349409",
  null
  
)

export default component.exports